import React from 'react';
import styled from 'styled-components';
import SGBody from 'components/Typography/SGBody';

const StyledStatusCell = styled.div`
  display: flex;
  align-items: center;
`;

const StyledSiteStatusIndicator = styled.div`
  background-color: transparent;
  border-radius: 50%;
  height: 12px;
  width: 12px;
  margin-right: 12px;

  &.pre-open {
    background-color: ${props => props.theme.yellow};
  }
  &.open {
    background-color: ${props => props.theme.secondary};
  }
  &.remodel {
    background-color: ${props => props.theme.yellow};
  }
  &.closed {
    background-color: ${props => props.theme.red};
  }
  &.unknown {
    background-color: ${props => props.theme.grey};
  }
`;

const statusClass: Record<string, string> = {
  PreOpen: 'pre-open',
  Open: 'open',
  Remodel: 'remodel',
  Closed: 'closed',
  Unknown: 'unknown',
};

const statusLabel: Record<string, string> = {
  PreOpen: 'Pre-Open',
  Open: 'Open',
  Remodel: 'Remodel',
  Closed: 'Closed',
  Unknown: 'Unknown',
};

interface SiteStatusIndicatorProps {
  status: string;
}

function SiteStatusIndicator({status}: SiteStatusIndicatorProps) {
  const indicatorClass: string | undefined = statusClass[status];
  const statusText: string | undefined = statusLabel[status];

  return (
    <StyledStatusCell>
      <StyledSiteStatusIndicator className={indicatorClass ? indicatorClass : 'unknown'} />
      <SGBody variant={'b4'}>{statusText ? statusText : status}</SGBody>
    </StyledStatusCell>
  );
}

export default SiteStatusIndicator;
